export default __webpack_public_path__ + "static/r-90-5-ac2b8e0d732de2c6144836c4e79d00ad.jpg";